import React, { useState } from 'react';
import './css/index.scss';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import MyButton from '../../../../components/MyButton';
import Api from '../../../../Api';
import { getFirstCarouselPhotoUrl, resolvePhotoUrl } from '../../../../helpers/resolvePhotoUrl';
import { REPORT_MODAL_STATES } from '../../constants';
import ReportsModal from '../ReportsModal';
import styles from '../../css/index.module.scss';
import EmptyHeight from '../../../../components/EmptyHeight';
import { UNNAMED_USER_EMAIL } from '../../../../helpers/constants';

function ReportOrganizations({ complaints, updateComplaints }) {
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalState, setModalState] = useState(null);
  const [complaintId, setComplaintId] = useState(null);
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  const onApproveClick = (complaint) => {
    if (complaint && complaint._id) {
      setModalState(REPORT_MODAL_STATES.seen);
      setIsModalVisible(true);
      setComplaintId(complaint._id);
    } else {
      console.error('Invalid complaint object:', complaint);
    }
  };

  const onPhotoItemClick = (photo, complaint) => () => {
    setSelectedPhoto(photo);
    setModalState(REPORT_MODAL_STATES.viewPhoto);
    setIsModalVisible(true);
    setComplaintId(complaint);
  };

  return (
    <>
      <ReportsModal
        isVisible={isModalVisible}
        setIsVisible={setIsModalVisible}
        modalState={modalState}
        selectedPhoto={selectedPhoto}
        setSelectedPhoto={setSelectedPhoto}
        complaintId={complaintId}
        updateComplaints={updateComplaints}
        isOrganizationOrInfo
        modalApproveInfoText="Вы уверены, что хотите пометить как прочитанное?"
      />
      {complaints?.length ? complaints.map((item, index) => (item.subject
        && (
        <div key={item._id} className={styles.reportItem}>
          <div className={styles.reportRow}>
            <div style={{ width: '140px' }} onClick={() => window.open(`/organizations/single-view?id=${item.subject?._id}`, '_blank')}>
              <img
                className={styles.headerPhoto}
                src={getFirstCarouselPhotoUrl(item.subject, Api.url) || ''}
                alt="subject photo"
              />
            </div>
            <div style={{ width: '300px' }}>
              <p className={styles.text}>{item.subject?.name}</p>
              <EmptyHeight height={8} />
              <p className={styles.textGrey}>
                ID ORG:
                {' '}
                {item.subject?._id}
              </p>
            </div>
            <div style={{ width: '240px' }}>
              <p className={styles.text}>{item.subject?.user?.email}</p>
              <EmptyHeight height={8} />
              <p className={styles.textGrey}>
                ID user:
                {item.subject?.user?._id}
              </p>
            </div>
            <div style={{ width: '140px' }}>
              <p className={styles.text}>{moment(item.updatedAt).format('DD/MM/YYYY')}</p>
              <EmptyHeight height={8} />
              <p className={styles.textGrey}>Дата</p>
            </div>
            <MyButton
              text="Ок"
              onClick={() => onApproveClick(item)}
            />
          </div>
          <EmptyHeight height={35} />
          <div className={styles.reportRow}>
            <div style={{ width: '470px' }}>
              <p className={styles.textGrey}>Описание от заявителя</p>
              <EmptyHeight height={8} />
              <p className={styles.text}>
                {item.text}
              </p>
            </div>

            {item.from_user?.email && item.from_user?.email !== UNNAMED_USER_EMAIL && (
              <div style={{ width: '180px' }}>
                <p className={styles.textGrey}>Данные заявителя</p>
                <EmptyHeight height={8} />
                <p className={styles.text}>
                  {`${item.from_user?.email} ${item.from_user?.display_name}`}
                </p>
              </div>
            )}

            <div style={{ width: '240px' }}>
              <p className={styles.textGrey}>Приложения от заявителя</p>
              <EmptyHeight height={8} />
              <div className={styles.photosRow}>
                {item.photos.map((photo, i) => (
                  <img
                    key={i}
                    src={resolvePhotoUrl(photo, Api.url) || ''}
                    alt=""
                    className={styles.photo}
                    onClick={onPhotoItemClick(photo, item._id)}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
        )
      )) : <p style={{ marginTop: 40, marginLeft: 10 }}>Пусто.</p>}
    </>
  );
}

export default ReportOrganizations;
